import { useEffect } from "react";
import WriteReviewForm from "../WriteReviewForm";

const StarIcon = ({ filled = false, size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill={filled ? "currentColor" : "#e6e6e6"}
  >
    <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
  </svg>
);

const WriteReviewModal = ({ open, onClose, onSuccess }) => {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="write_review_modal_overlay" onClick={onClose} role="presentation">
      <div
        className="write_review_modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="writeReviewModalTitle"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="write_review_modal_header">
          <span className="reviews_widget_badge">
            <StarIcon filled size={16} />
          </span>
          <div className="write_review_modal_heading">
            <h2 id="writeReviewModalTitle">Write Your Review</h2>
            <p>Share your ride experience with Orbi.</p>
          </div>
          <button
            type="button"
            className="write_review_modal_close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="write_review_modal_body">
          <WriteReviewForm
            onSuccess={() => {
              onClose();
              if (onSuccess) onSuccess();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default WriteReviewModal;
